import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Gift, Sparkles, Ban } from "lucide-react";
import { useI18n } from "../i18n/LanguageContext";
import { api } from "../lib/api";

// Public, private-by-token reveal page: no login required. Shows only this participant's match.
export default function SecretSantaReveal() {
  const { t, lang } = useI18n();
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  const [revealed, setRevealed] = useState(false);

  useEffect(() => {
    api.get(`/secret-santa/reveal/${token}?lang=${lang}`).then(({ data: d }) => setData(d)).catch(() => setError(true));
  }, [token, lang]);

  if (error) return <div className="flex min-h-screen items-center justify-center bg-xmas-navy text-xmas-slate" data-testid="ss-reveal-invalid">{t("ss.reveal_invalid")}</div>;
  if (!data) return <div className="flex min-h-screen items-center justify-center bg-xmas-navy"><div className="h-10 w-10 animate-spin rounded-full border-2 border-xmas-gold border-t-transparent" /></div>;

  const wl = data.receiver.wishlist || {};
  return (
    <div className="flex min-h-screen items-center justify-center bg-xmas-navy px-4 py-10">
      <div className="glass w-full max-w-md rounded-3xl p-8 text-center" data-testid="ss-reveal-page">
        <p className="text-[11px] uppercase tracking-widest text-xmas-gold">MY CHRISTMAS · {data.group_name}</p>
        <h1 className="mt-3 font-display text-2xl text-xmas-snow">{t("ss.reveal_hello", { name: data.participant_name })}</h1>
        {!revealed ? (
          <>
            <Gift className="mx-auto my-6 h-14 w-14 text-xmas-gold" />
            <p className="text-sm text-xmas-slate">{t("ss.reveal_private_hint")}</p>
            <button onClick={() => setRevealed(true)} data-testid="ss-reveal-public-btn" className="btn-gold mt-6 w-full rounded-xl py-3.5 text-sm font-bold uppercase tracking-wider">
              {t("ss.reveal")}
            </button>
          </>
        ) : (
          <div className="float-up mt-6" data-testid="ss-reveal-result">
            <p className="text-sm text-xmas-slate">{t("ss.you_got")}</p>
            <p className="mt-2 font-display text-4xl text-xmas-gold" data-testid="ss-reveal-name">{data.receiver.name}</p>
            <Sparkles className="mx-auto mt-3 h-6 w-6 text-xmas-gold" />
            {(wl.items?.length || wl.dislikes) ? (
              <div className="mt-6 rounded-2xl bg-xmas-navy/50 p-4 text-left" data-testid="ss-reveal-wishlist">
                <p className="mb-2 text-xs uppercase tracking-widest text-xmas-gold">{t("ss.their_wishlist", { name: data.receiver.name })}</p>
                {(wl.items || []).map((it, i) => <p key={i} className="text-sm text-xmas-snow">• {it}</p>)}
                {wl.link && <a href={wl.link} target="_blank" rel="noreferrer" data-testid="ss-reveal-wish-link" className="mt-1 block truncate text-xs text-xmas-gold underline">{wl.link}</a>}
                {wl.dislikes && <p className="mt-2 flex items-center gap-1.5 text-sm text-xmas-slate"><Ban className="h-3.5 w-3.5" /> {t("ss.dislikes")}: {wl.dislikes}</p>}
              </div>
            ) : <p className="mt-6 text-sm text-xmas-slate">{t("ss.no_wishlist")}</p>}
            <p className="mt-6 text-xs text-xmas-slate">{t("ss.reveal_keep_secret")}</p>
          </div>
        )}
      </div>
    </div>
  );
}
